import { getNewsConstants } from '../constants'

const initialState = {}

export default (state = initialState, action = {}) => {
    switch (action.type) {
        case getNewsConstants.REQUEST:
            return {
                ...state,
                pending: true,
            }
        case getNewsConstants.SUCCESS:
            return {
                ...state,
                news: action.response,
                pending: false,
            }
        case getNewsConstants.FAILURE:
            return {
                ...initialState,
                pending: false,
            }
        default:
            return state
    }
}



// WEBPACK FOOTER //
// /usr/src/app/frontend/src/connectors/redux/reducers/getNews.js